export const errorHandler = (error) => {
  let jsonResponse
  try {
    jsonResponse = JSON.parse(error.request.response)
  }
  catch {} // TODO: should we give a default json error response ?

  return { status: error.request.status, data: jsonResponse }
}
